import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
} from "react-icons/fa";



const Social = (props) => {

  return (
    <div className="nav social-icons justify-content-center text-sm-center justify-content-md-end">
      {console.log(props.site.facebookLink)}
      {props.site.facebookLink !== null && props.site.facebookLink !== "" ?
        <a href={props.site.facebookLink} rel="noopener noreferrer" target="_blank">
          <FaFacebookF />
        </a>
        :
        <></>
      }
      {props.site.twitterLink !== null && props.site.twitterLink !== "" ?
        <a href={props.site.twitterLink} rel="noreferrer" target="_blank">
          <FaTwitter />
        </a>
        :
        <></>
      }
      {props.site.instagramLink !== null && props.site.instagramLink !== "" ?
        <a href={props.site.instagramLink} rel="noreferrer" target="_blank">
          <FaInstagram />
        </a>
        :
        <></>
      }
      {props.site.tikTokLink !== null && props.site.tikTokLink !== "" ?
        <a href={props.site.tikTokLink} rel="noreferrer" target="_blank">
          <FaTiktok />
        </a>
        :
        <></>
      }
      {props.site.linkedInLink !== null && props.site.linkedInLink !== "" ?
        <a href={props.site.linkedInLink} rel="noreferrer" target="_blank">
          <FaLinkedinIn />
        </a>
        :
        <></>
      }
    </div>
  );
};

export default Social;
